import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useUserRole } from '@/hooks/useUserRole';

/**
 * SecurityCleanupService - Handles automated cleanup of sensitive data
 * Only runs for superadmin users to prevent unauthorized access
 */
export const SecurityCleanupService: React.FC = () => {
  const { isSuperAdmin } = useUserRole();

  useEffect(() => {
    // Only run cleanup for superadmins
    if (!isSuperAdmin()) return;

    const runDataCleanup = async () => {
      try {
        console.info('Security: Running automated data cleanup...');
        
        const { error } = await supabase
          .rpc('cleanup_old_sensitive_data');

        if (error) {
          console.error('Security cleanup failed:', error);
        } else {
          console.info('Security: Data cleanup completed successfully');
        }
      } catch (err) {
        console.error('Security cleanup error:', err);
      }
    };

    // Run cleanup immediately if superadmin
    runDataCleanup();

    // Schedule periodic cleanup every 24 hours
    const cleanupInterval = setInterval(runDataCleanup, 24 * 60 * 60 * 1000);

    return () => {
      clearInterval(cleanupInterval);
    };
  }, [isSuperAdmin]);

  // This component renders nothing but handles cleanup in the background
  return null;
};